var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "marker",
    viewBox: "0 0 34 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "marker-1",
    d: "M17,0 C26.3888407,0 34,7.61115925 34,17 C34,26.3888407 17,48 17,48 C17,48 1.49213975e-13,26.3888407 1.49213975e-13,17 C1.49213975e-13,7.61115925 7.61115925,0 17,0 Z M17,10 C13.6862915,10 11,12.6862915 11,16 C11,19.3137085 13.6862915,22 17,22 C20.3137085,22 23,19.3137085 23,16 C23,12.6862915 20.3137085,10 17,10 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-3",
    transform: "translate(-15.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-4",
    transform: "translate(15.000000, 8.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "marker-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    id: "marker-6",
    xlinkHref: "#marker-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "marker-7",
    className: "fill-selector",
    fill: "#B8B8B8",
    xlinkHref: "#marker-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "marker-8",
    mask: "url(#marker-5)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "marker-9",
    className: "fill-selector",
    transform: "translate(-15.000000, -8.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "marker-10",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarker);
export default __webpack_public_path__ + "static/media/marker.cb28b52bb06ba6aa1ee05c2ea7bc227e.svg";
export { ForwardRef as ReactComponent };